import { GO_HOME, CONTAINER_PAGE_NOTFOUND } from 'constants/constant';
import React from 'react';
import { Link } from 'react-router-dom';
const NotFound = () => (
	<div>
		<h1>{CONTAINER_PAGE_NOTFOUND}</h1>
		<Link to="/">{GO_HOME}</Link>
	</div>
);

export default NotFound;
